import styled from 'styled-components';

import { buildStyledComponent } from 'decisiv-ui-utils';

const styles = ({ theme }) => `
  display: flex;
  flex: 1;
`;

export default buildStyledComponent('Layout__Body', styled.section, styles);



// WEBPACK FOOTER //
// ./src/blocks/Layout/Body.js